import { get, put } from "../utils/request";

export const getServiceEntryByDomain = () => {
  return get(`/v1/service-entries/groupByDomain`);
}

export const updateServiceEntryById = (serviceEntryId, body) => {
  return put(`/admin/v1/service-entries/${serviceEntryId}`, body);
}
